import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

interface PricingCardProps {
  tier: 'silver' | 'gold' | 'platinum';
  price: string;
  features: string[];
  onSelect: () => void;
}

const tierStyles = {
  silver: {
    background: 'bg-gradient-to-br from-gray-100 to-gray-200',
    border: 'border-gray-300',
    button: 'bg-gray-600 hover:bg-gray-700',
    icon: 'text-gray-600'
  },
  gold: {
    background: 'bg-gradient-to-br from-orange-50 to-orange-100',
    border: 'border-orange-200',
    button: 'bg-orange-500 hover:bg-orange-600',
    icon: 'text-orange-500'
  },
  platinum: {
    background: 'bg-gradient-to-br from-purple-50 to-purple-100',
    border: 'border-purple-200',
    button: 'bg-purple-600 hover:bg-purple-700',
    icon: 'text-purple-600'
  }
};

export const PricingCard = ({ tier, price, features, onSelect }: PricingCardProps) => {
  const styles = tierStyles[tier];
  
  return (
    <div className={`rounded-xl ${styles.background} border ${styles.border} p-6 shadow-lg transition-transform hover:scale-105`}>
      <h3 className="text-2xl font-bold capitalize mb-2">{tier}</h3>
      <div className="mb-4">
        <span className="text-4xl font-bold">{price}</span>
        <span className="text-gray-600">/month</span>
      </div>
      <ul className="space-y-3 mb-6">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center gap-2">
            <Check className={`h-5 w-5 ${styles.icon}`} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <Button 
        className={`w-full ${styles.button} text-white`}
        onClick={onSelect}
      >
        Select {tier}
      </Button>
    </div>
  );
};